import { useCallback, useMemo, useState } from 'react'

import { FilterCompanyAdverseMediaWebPage } from 'commons/service/bank/companyDetails'
import { useTableState } from 'ui/components/Table'

export const useComponentsEssence = (
  companyId: number,
  onFilterCompanyAdverseMediaWebPage: (filter: FilterCompanyAdverseMediaWebPage) => void
) => {
  const [loading, setLoading] = useState(false)

  const defaultFilter = useMemo(
    () => ({
      relationshipId: companyId,
      page: undefined,
      size: undefined
    }),
    [companyId]
  )

  const [tableFilter, setTableFilter] = useState<FilterCompanyAdverseMediaWebPage>(defaultFilter)

  const tableState = useTableState({ filter: {} })

  const changePagination = useCallback(
    async (page: number, size: number) => {
      setLoading(true)

      tableState.onPageChange(page, size)

      const filter = {
        ...tableFilter,
        page,
        size
      }

      setTableFilter(filter)

      await onFilterCompanyAdverseMediaWebPage(filter)

      setLoading(false)
    },
    [onFilterCompanyAdverseMediaWebPage, tableFilter, tableState]
  )

  return {
    loading,
    tableState,
    changePagination
  }
}
